export const NAME = 'producedProduction-new';

export const modalWindow = 'modalWindow';
export const DuplicityErrorCode = 999000029;

export const sellerNumbersSourceForProducedProduction = 'DB';
export const sellerNumbersSourceForOther = 'CDU';

export const submitTypes = {
	add: 'add',
	addAndClose: 'addAndClose',
};
